var _defs, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnknown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e359a076-c8df-4ced-8bfa-1a94b074012f",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 466.7 326.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".bdcfa634-fe01-4284-9420-67524f66ef39,.f86db69e-b215-421a-a2e6-0d05ef34d9c9{fill:#123466;}.f86db69e-b215-421a-a2e6-0d05ef34d9c9{fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "bdcfa634-fe01-4284-9420-67524f66ef39",
    d: "M365.3,200.7H412v46.6H365.3Z",
    transform: "translate(-15.3 -14)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "bdcfa634-fe01-4284-9420-67524f66ef39",
    d: "M248.7,200.7H85.3v46.6H248.7Z",
    transform: "translate(-15.3 -14)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "f86db69e-b215-421a-a2e6-0d05ef34d9c9",
    d: "M15.3,84a70,70,0,0,1,70-70H412a69.9,69.9,0,0,1,70,70V270.7a70,70,0,0,1-70,70H85.3a70.1,70.1,0,0,1-70-70Zm70-23.3H412A23.3,23.3,0,0,1,435.3,84v23.3H62V84A23.3,23.3,0,0,1,85.3,60.7ZM62,177.3v93.4A23.3,23.3,0,0,0,85.3,294H412a23.3,23.3,0,0,0,23.3-23.3V177.3Z",
    transform: "translate(-15.3 -14)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnknown);
export default __webpack_public_path__ + "static/media/Unknown.a5cfc05fb3bfe4c52969d203f0ce0d6b.svg";
export { ForwardRef as ReactComponent };